import { translate as t } from '@thoughtspot/i18n';
import { ErrorCode } from '@thoughtspot/radiant-react/widgets/alert/alert-constants';
import { MutedAlert } from '@thoughtspot/radiant-react/widgets/alert/muted/muted-alert';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { TableListView } from '@thoughtspot/radiant-react/widgets/table/table-list-view';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { EmptyCell } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/empty-cell/empty-cell';
import React, { useCallback, useMemo, useState } from 'react';
import { getNormalizedData } from "../../../utils/chart-customization";
import styles from './geomap.module.scss';
const getCustomRegionListColumns = () => [
    {
        headerName: t('chartCustomization.geomaps.list.header.mapName'),
        colId: 'mapName',
        field: 'mapName',
        flex: 2,
        sortable: true,
        cellRenderer: CellType[CellType.text],
        cellClass: styles.geomapName,
    },
    {
        headerName: t('chartCustomization.geomaps.list.header.uploadedBy'),
        colId: 'uploadedBy',
        field: 'uploadedBy',
        flex: 2,
        sortable: true,
        isNameLink: false,
        cellRenderer: CellType[CellType.avatar],
    },
    {
        headerName: t('chartCustomization.geomaps.list.header.lastModified'),
        colId: 'lastModified',
        field: 'lastModified',
        flex: 2,
        sortable: true,
        cellRenderer: CellType[CellType.text],
    },
    {
        cellRenderer: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement(Horizontal, { vAlignContent: "center" },
            React.createElement(Button, { type: "tertiary", text: t('chartCustomization.geomaps.list.action.edit'), size: "m", id: cellValues.editKey, onClick: cellValues.rowEditFunction, isDisabled: !!cellValues.disableUpdateMsg, tooltip: cellValues.disableUpdateMsg, "data-testid": `edit-geomap-btn-${cellValues.dataTestIdSuffix}` }),
            React.createElement("div", { className: styles.divider }),
            React.createElement(Button, { type: "tertiary", text: t('chartCustomization.geomaps.list.action.delete'), size: "m", id: cellValues.deleteKey, onClick: cellValues.rowDeleteFunction, isDisabled: !!cellValues.disableUpdateMsg, tooltip: cellValues.disableUpdateMsg, "data-testid": `delete-geomap-btn-${cellValues.dataTestIdSuffix}` }))))),
        colId: 'actions',
        flex: 1,
        sortable: false,
    },
];
const EmptyGeoMapList = ({ onAddMapClick }) => (React.createElement(MutedAlert, { global: true, imageVisible: true, errorCode: ErrorCode.GLOBAL_SEARCH, title: t('chartCustomization.geomaps.content.noData.title'), description: t('chartCustomization.geomaps.content.noData.description'), className: styles.mutedAlertContainer, primaryAction: {
        label: t('chartCustomization.geomaps.content.addMap'),
        onClick: onAddMapClick,
    } }));
export const CustomRegionList = ({ data, handleRowEdit, handleOnDelete, loading, addCustomRegion, currentOrgId, }) => {
    const [sortOrder, setSortOrder] = useState([null, null, null]);
    const handleSortChange = useCallback((sortState) => {
        setSortOrder(sortState);
    }, [data]);
    const parsedData = useMemo(() => {
        return getNormalizedData(data, sortOrder, handleRowEdit, handleOnDelete, currentOrgId);
    }, [data, sortOrder]);
    if (!loading && !data?.length) {
        return React.createElement(EmptyGeoMapList, { onAddMapClick: addCustomRegion });
    }
    return (React.createElement(TableListView, { data: parsedData, options: {}, columns: getCustomRegionListColumns(), sortingOrder: sortOrder, loading: loading, "data-testid": "customRegionListTable", onSortingChanged: handleSortChange, className: styles.customRegionList }));
};
//# sourceMappingURL=custom-region-list.js.map